import React, { useState, useEffect } from "react";
import "../style/fresarrivelcarousel.css";

const ThreeDCarousel= ({ images = [] }) => {
  const [activeIndex, setActiveIndex] = useState(0);
       // ----- Auto slide
  useEffect(() => {
    const timer = setInterval(() => {
      nextSlide();
    }, 3000);
    return () => clearInterval(timer);
  });

  const nextSlide = () => {
    setActiveIndex((prev) => (prev + 1) % images.length);
  };

  const prevSlide = () => {
    setActiveIndex((prev) =>
      prev === 0 ? images.length - 1 : prev - 1
    );
  };

  return (
      <>
        <div className="newArrivel wow animate__animated animate__fadeInRight">  
            <div className="carousel-container">
            <div className="carousel-3d">
                {images.map((img, index) => {
                const offset = index - activeIndex;
                const classNames = `slide ${
                    offset === 0
                    ? "active"
                    : offset === -1 || offset === images.length - 1
                    ? "left"
                    : offset === 1 || offset === -(images.length - 1)
                    ? "right"
                    : ""
                }`;

                return (
                    <img
                    key={index}
                    src={img}
                    alt={images.index}
                    className={classNames}
                    />
                );
                })}

                <button className="nav prev" onClick={prevSlide}> <i className="bi bi-chevron-left"></i> </button>
                <button className="nav next" onClick={nextSlide}> <i className="bi bi-chevron-right"></i> </button>
            </div>

            {/* Thumbnail Carousel */}

            {/* <div className="thumb-row">
                    {images.map((img, index) => (
                    <img
                        key={index}
                        src={img}
                        onClick={() => setActiveIndex(index)}
                        className={`thumb ${activeIndex === index ? "thumb-active" : ""}`}
                        alt=""
                    />
                    ))}
              </div> */}

            </div>
        </div>

      </>
  );
};
export default ThreeDCarousel;
